import React from 'react'
import SubSteps from '../components/subSteps'
import Tipologia from '../components/Tipologia'
import DicciDiPiu from '../components/DicciDiPiu'
import Sesso from '../components/Sesso'
import Mappa from '../components/Mappa'
import ExtraInfo from '../components/extraInfo'
import Furniture from '../components/furniture'
import RiepilogoDettagli from '../components/riepilogoDettagli'
import ImagesBlock from '../components/imageBlock'
import Title from '../components/title'
import Telefono from '../components/telefono'
import RiepilogoFotoDescrizione from '../components/riepilogoFotoDescrizione'
import Tempistiche from '../components/tempistiche'
import Spese from '../components/Spese/index'
import RiepilogoCosti from '../components/riepilogoCosti'
import Regole from '../components/regole'
// ICONS FOR EXTRA
import { ReactComponent as Balcone } from './svg/zappyrent_ico_balcone.svg'
import { ReactComponent as Ascensore } from './svg/zappyrent_ico_ascensore.svg'
import { ReactComponent as NoAscensore } from './svg/zappyrent_ico_no_ascensore.svg'
import { ReactComponent as Parcheggio } from './svg/zappyrent_ico_parcheggio.svg'
import { ReactComponent as Salotto } from './svg/zappyrent_ico_salotto.svg'
import { ReactComponent as Giardino } from './svg/zappyrent_ico_giardino.svg'

// ICONS FOR FURNITURE
import { ReactComponent as Lavatrice } from './svg/zappyrent_ico_lavatrice.svg'
import { ReactComponent as Lavastoviglie } from './svg/zappyrent_ico_lavastoviglie.svg'
import { ReactComponent as Forno } from './svg/zappyrent_ico_forno.svg'
import { ReactComponent as Microonde } from './svg/zappyrent_ico_microonde.svg'
import { ReactComponent as Armadio } from './svg/zappyrent_ico_armadio.svg'
import { ReactComponent as TV } from './svg/zappyrent_ico_tv.svg'
import { ReactComponent as Matrimoniale } from './svg/zappyrent_ico_matrimoniale.svg'
import { ReactComponent as Internet } from './svg/zappyrent_ico_wifi.svg'
import { ReactComponent as Condizionatore } from './svg/zappyrent_ico_condizionatore.svg'
import { ReactComponent as Scrivania } from './svg/zappyrent_ico_scrivania.svg'

// ICONS FOR FEES
import { ReactComponent as Acqua } from './svg/zappyrent_ico_acqua.svg'
import { ReactComponent as Rifiuti } from './svg/zappyrent_ico_rifiuti.svg'
import { ReactComponent as Condominio } from './svg/zappyrent_ico_condominio.svg'
import { ReactComponent as Gas } from './svg/zappyrent_ico_gas.svg'
import { ReactComponent as Elettricita } from './svg/zappyrent_ico_luce.svg'

import { ReactComponent as Male } from '../assets/svg/male.svg'
import { ReactComponent as Female } from '../assets/svg/female.svg'
import { ReactComponent as Restroom } from '../assets/svg/restroom.svg'

import axios from 'axios'
import Contratto from '../components/Contratto'

export const steps = [
  {
    title: 'Dettagli Annuncio',
    description: 'Qui potrai caricare i dettagli del tuo annuncio',
    content: (props) => <SubSteps {...props} formName="property" />,
  },
  {
    title: 'Descrizione & Foto',
    description: 'Qui aggiungerai le foto per il tuo annuncio',
    content: (props) => <SubSteps {...props} formName="property" />,
  },
  {
    title: 'Costi & Regole',
    description: 'Qui puoi definire le regole del tuo annuncio',
    content: (props) => <SubSteps {...props} formName="property" />,
  },
]

export const substeps = [
  {
    steps: [
      {
        title: 'Cosa vuoi affittare?',
        content: <Tipologia />,
        onEdit: [0, 1, 2],
        fields: ['tipologia'],
        draft: ['type'],
        countStep: true,
      },
      {
        title: 'Dicci di più sul tuo appartamento',
        content: <DicciDiPiu />,
        fields: [
          'numeroPostiLetto',
          'numeroCamereLetto',
          'numeroBagni',
          'numeroCoinquilini',
          'tipoBagno',
        ],
        draft: [
          'no_of_beds',
          'total_bedrooms',
          'bathrooms',
          'total_house_mates',
          'bathroom_type',
        ],
        countStep: true,
      },
      {
        title: "Vuoi affittare l'appartamento a",
        content: <Sesso />,
        skip: (formData) => {
          if (formData.tipologia !== '2' && formData.tipologia !== '3') {
            return true
          }
          return false
        },
        fields: ['sesso'],
        draft: ['house_for'],
        countStep: true,
      },
      {
        title: 'Dove si trova',
        content: <Mappa />,
        fields: ['indirizzo', 'CAP', 'citta'],
        draft: [
          'address',
          'latitude',
          'longitude',
          'cap',
          'city',
          'street',
          'street_number',
          'province',
          'region',
          'country',
        ],
        countStep: true,
      },
      {
        title: 'Dicci di più',
        content: <ExtraInfo />,
        fields: ['piano', 'extra', 'size', 'building_floors'],
        draft: [
          'size',
          'floors',
          'garden',
          'balcony_terrace',
          'car_parking',
          'elevator',
          'living_room',
          'building_floors',
        ],
        countStep: true,
      },
      {
        title: 'Cosa metti a disposizione',
        content: <Furniture />,
        canSkip: true,
        fields: ['furniture'],
        draft: ['property_furniture'],
        countStep: true,
      },
      {
        title: 'Riepilogo',
        status: 'finish',
        content: <RiepilogoDettagli />,
        btnDisabled: true,
      },
    ],
  },
  {
    steps: [
      {
        title: 'Diamo un titolo',
        content: <Title />,
        canSkip: true,
        fields: ['titolo', 'descrizione'],
        draft: ['short_desc', 'prop_extra_info'],
        countStep: true,
      },
      {
        title: 'Aiuto ad affittare',
        content: <Telefono />,
        skip: async (formData, addValue, isEditing) => {
          try {
            const { data: res } = await axios.post(
              `${process.env.REACT_APP_API_URL}/api/user`
            )
            addValue({
              nome: `${res.data.first_name} ${res.data.last_name}`,
              telefono: res.data.phone_no,
            })
            const isValidNumber =
              !!res.data.phone_no &&
              res.data.phone_no !== '-' &&
              !!res.data.phone_no_verified
            return isValidNumber
          } catch (e) {
            return false
          }
        },
        btnDisabled: true,
        fields: ['nome', 'telefono'],
        countStep: true,
      },
      {
        title: 'Riepilogo',
        status: 'finish',
        content: <RiepilogoFotoDescrizione />,
        btnDisabled: true,
      },
    ],
  },
  {
    steps: [
      {
        title: 'Permanenze',
        content: <Tempistiche />,
        fields: ['libero', 'permanenza'],
        draft: ['start_date', 'min_stay'],
        countStep: true,
      },
      {
        title: 'Spese',
        content: <Spese />,
        fields: [
          'canone',
          'caparre',
          'spese',
          'tipoPagamento',
          'costoSpeseNonIncluse',
        ],
        draft: [
          'price',
          'deposit',
          'water',
          'gas',
          'electricity',
          'garbage',
          'internet',
          'condominio',
          'total_cost',
        ],
        countStep: true,
      },
      {
        title: 'Contratto',
        content: <Contratto />,
        btnLabel: 'Accetta e continua',
        fields: ['with_insurance'],
        draft: ['with_insurance'],
        countStep: true,
      },
      {
        title: 'Regole',
        content: <Regole />,
        fields: ['disdette', 'animali', 'refunded'],
        draft: ['canc_rules', 'pets_allowed', 'refunded'],
        countStep: true,
      },
      {
        title: 'Foto',
        content: <ImagesBlock />,
        canSkip: true,
        fields: ['images', 'booking_3d'],
        draft: ['property_main_image', 'property_more_images', 'booking_3d'],
        countStep: true,
      },
      {
        title: 'Riepilogo',
        status: 'finish',
        content: <RiepilogoCosti />,
        btnDisabled: true,
      },
    ],
  },
]

export const tipologie = [
  'Monolocale',
  'Appartamento',
  'Stanza Privata',
  'Posto Letto',
]

export const titleQuestion = [
  'Dicci di più sul tuo monolocale',
  'Dicci di più sul tuo appartamento',
  'Dicci di più sulla tua camera che vuoi affittare',
  'Dicci di più sul posto letto che vuoi affittare',
]

export const numeroPostiLetto = [
  {
    label: '1 posto letto',
    value: '1',
  },
  {
    label: '2 posti letto',
    value: '2',
  },
  {
    label: '3 posti letto',
    value: '3',
  },
  {
    label: '4 posti letto',
    value: '4',
  },
  {
    label: '5 posti letto',
    value: '5',
  },
  {
    label: '6+ posti letto',
    value: '6',
  },
]

export const numeroCamereLetto = [
  {
    label: '1 camera da letto',
    value: '1',
  },
  {
    label: '2 camere da letto',
    value: '2',
  },
  {
    label: '3 camere da letto',
    value: '3',
  },
  {
    label: '4 camere da letto',
    value: '4',
  },
  {
    label: '5 camere da letto',
    value: '5',
  },
  {
    label: '6+ camere da letto',
    value: '6',
  },
]

export const numeroCoinquilini = [
  {
    label: '1 inquilino',
    value: '1',
  },
  {
    label: '2 inquilini',
    value: '2',
  },
  {
    label: '3 inquilini',
    value: '3',
  },
  {
    label: '4 inquilini',
    value: '4',
  },
  {
    label: '5 inquilini',
    value: '5',
  },
  {
    label: '6+ inquilini',
    value: '6',
  },
]

export const numeroBagni = [
  {
    label: '1 bagno',
    value: '1',
  },
  {
    label: '2 bagni',
    value: '2',
  },
  {
    label: '3 bagni',
    value: '3',
  },
  {
    label: '4+ bagni',
    value: '4',
  },
]

export const piani = [
  {
    label: 'Seminterrato',
    value: '-1',
  },
  {
    label: 'Piano terra',
    value: '0',
  },
  {
    label: 'Primo piano',
    value: '1',
  },
  {
    label: 'Secondo piano',
    value: '2',
  },
  {
    label: 'Terzo piano',
    value: '3',
  },
  {
    label: 'Quarto piano',
    value: '4',
  },
  {
    label: 'Quinto piano',
    value: '5',
  },
  {
    label: 'Sesto piano o superiore',
    value: '6',
  },
  {
    label: 'Ultimo',
    value: 'last',
  },
  {
    label: 'Su più piani',
    value: 'more floors',
  },
]

export const gender = [
  {
    value: 'M',
    label: 'Uomini',
    icon: <Male width={50} />,
  },
  {
    value: 'F',
    label: 'Donne',
    icon: <Female width={50} />,
  },
  {
    value: 'U',
    label: 'Ambosessi',
    icon: <Restroom width={50} />,
  },
]

export const extra = [
  {
    value: 'balcone',
    label: 'Terrazza',
    draft: 'balcony_terrace',
    icon: <Balcone width={50} />,
  },
  {
    value: 'ascensore',
    label: 'Ascensore',
    draft: 'elevator',
    icon: <Ascensore width={50} />,
    clicked_icon: <NoAscensore width={50} />,
  },
  {
    value: 'auto',
    label: 'Posto Auto',
    draft: 'car_parking',
    icon: <Parcheggio width={50} />,
  },
  {
    value: 'soggiorno',
    label: 'Soggiorno',
    draft: 'living_room',
    icon: <Salotto width={50} />,
  },
  {
    value: 'giardino',
    label: 'Giardino',
    draft: 'garden',
    icon: <Giardino width={50} />,
  },
]

export const furniture = [
  {
    label: 'Lavatrice',
    value: 'lavatrice',
    draft: 'Lavatrice',
    icon: <Lavatrice width={50} />,
  },
  {
    label: 'Lavastoviglie',
    value: 'lavastoviglie',
    draft: 'Lavastoviglie',
    icon: <Lavastoviglie width={50} />,
  },
  {
    label: 'Internet',
    value: 'internet',
    draft: 'Wifi',
    icon: <Internet width={50} />,
  },
  {
    label: 'Aria condizionata',
    value: 'aria_condizionata',
    draft: 'Aria Condizionata',
    icon: <Condizionatore width={50} />,
  },
  {
    label: 'TV',
    value: 'tv',
    draft: 'TV',
    icon: <TV width={50} />,
  },
  {
    label: 'Forno',
    value: 'forno',
    draft: 'Forno',
    icon: <Forno width={50} />,
  },
  {
    label: 'Forno a microonde',
    value: 'microonde',
    draft: 'Microonde',
    icon: <Microonde width={50} />,
  },
  {
    label: 'Letto matrimoniale',
    value: 'matrimoniale',
    draft: 'Letto Matrimoniale',
    icon: <Matrimoniale width={50} />,
  },
  {
    label: 'Armadio',
    value: 'armadio',
    draft: 'Armadio',
    icon: <Armadio width={50} />,
  },
  {
    label: 'Scrivania',
    value: 'scrivania',
    draft: 'Scrivania',
    icon: <Scrivania width={50} />,
  },
]

export const speseProps = [
  {
    label: 'Acqua',
    value: 'acqua',
    draft: 'water',
    icon: <Acqua width={50} />,
  },
  {
    label: 'Tassa sui rifiuti',
    value: 'rifiuti',
    draft: 'garbage',
    icon: <Rifiuti width={50} />,
  },
  {
    label: 'Spese condominiali',
    value: 'condominio',
    draft: 'condominio',
    icon: <Condominio width={50} />,
  },
  {
    label: 'Gas',
    value: 'gas',
    draft: 'gas',
    icon: <Gas width={50} />,
  },
  {
    label: 'Internet',
    value: 'internet',
    draft: 'internet',
    icon: <Internet width={50} />,
  },
  {
    label: 'Elettricità',
    value: 'elettricita',
    draft: 'electricity',
    icon: <Elettricita width={50} />,
  },
]

export const disdette = [
  {
    label: '1 mese',
    value: '1',
  },
  {
    label: '2 mesi',
    value: '2',
  },
  {
    label: '3 mesi',
    value: '3',
  },
  {
    label: '4 mesi',
    value: '4',
  },
]

export const permanenze = [
  {
    label: '6 mesi',
    value: '6',
  },
  {
    label: '12 mesi',
    value: '12',
  },
]

export const caparre = [
  {
    label: '1 mese',
    value: '1',
  },
  {
    label: '2 mesi',
    value: '2',
  },
  {
    label: '3 mesi',
    value: '3',
  },
  {
    label: 'Mezza mensilità',
    value: '0.5',
  },
]

export const orariPrenotazione = [
  {
    label: '9:00 - 11:00',
    value: '9',
  },
  {
    label: '11:00 - 13:00',
    value: '11',
  },
  {
    label: '13:00 - 15:00',
    value: '13',
  },
  {
    label: '15:00 - 17:00',
    value: '15',
  },
  {
    label: '17:00 - 19:00',
    value: '17',
  },
]

export const tipoSpese = [
  {
    label: 'Costo fisso mensile',
    value: '0',
  },
  {
    label: 'Pagamento a consumo',
    value: '1',
  },
]

export const localStorageVariables = [
  'prenotazione',
  'substep',
  'numero_telefono',
  'stepper',
  'lastStep',
  'location',
  'property',
]

export default {
  substeps,
  tipologie,
  titleQuestion,
  numeroBagni,
  numeroCamereLetto,
  numeroCoinquilini,
  numeroPostiLetto,
  piani,
  gender,
  extra,
  furniture,
  speseProps,
  disdette,
  permanenze,
  caparre,
  orariPrenotazione,
  tipoSpese,
}
